import axios from "axios";
// import alert from "@/lang/AlertMessages.js";
import label from "@/lang/StaticLabels.js";

let companySubSystemsRequest = null;

export default {
  // PBASE DropDowns  -----------------------------------------------
  getCompanies({ dispatch, commit }) {
    axios
      .get("base/api/v1/dropDown/companies")
      .then((res) => {
        commit("setCompanies", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getBranches({ dispatch, commit }) {
    axios
      .get("base/api/v1/dropDown/branches")
      .then((res) => {
        commit("setBranches", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getMyBranches({ dispatch, commit }) {
    axios
      .get("base/api/v1/admin/ChangeFiscalYear/GetMyBranches")
      .then((res) => {
        commit("setMyBranches", res.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getMyFiscalYear({ dispatch, commit }, data) {
    axios
      .get("base/api/v1/admin/ChangeFiscalYear/GetMyFiscalYear/" + data)
      .then((res) => {
        commit("setMyFiscalYear", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getRoles({ dispatch, commit }) {
    axios
      .get("base/api/v1/DropDown/Roles")
      .then((res) => {
        commit("setRoles", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getCustomers({ dispatch, commit }, data) {
    axios
      .get("base/api/v1/DropDown/Customers?" + data)
      .then((res) => {
        commit("setCustomers", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getBranchYears({ dispatch, commit }) {
    axios
      .get("base/api/v1/dropDown/branchYears")
      .then((res) => {
        commit("setBranchYears", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getUsers({ dispatch, commit }, data) {
    return axios
      .get("base/api/v1/dropDown/users?" + data)
      .then((res) => {
        commit("setUsers", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getCountries({ dispatch, commit }) {
    axios
      .get("base/api/v1/dropDown/Countries")
      .then((res) => {
        commit("setCountries", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getAllProvinces({ dispatch, commit }) {
    axios
      .get("base/api/v1/dropDown/Provinces")
      .then((res) => {
        commit("setAllProvinces", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getProvinces({ dispatch, commit }, data) {
    axios
      .get("base/api/v1/dropDown/Provinces?countryId=" + data)
      .then((res) => {
        commit("setProvinces", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getProvincesForAddress({ dispatch, commit }, data) {
    axios
      .get("base/api/v1/dropDown/Provinces?countryId=" + data)
      .then((res) => {
        commit("setProvincesForAddress", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getAllCities({ dispatch, commit }) {
    axios
      .get("base/api/v1/dropDown/Cities")
      .then((res) => {
        commit("setAllCities", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getCities({ dispatch, commit }, data) {
    axios
      .get("base/api/v1/dropDown/Cities?provinceId=" + data)
      .then((res) => {
        commit("setCities", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getCitiesForAddress({ dispatch, commit }, data) {
    axios
      .get("base/api/v1/dropDown/Cities?provinceId=" + data)
      .then((res) => {
        commit("setCitiesForAddress", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getRegions({ dispatch, commit }, data) {
    axios
      .get("base/api/v1/DropDown/Regions?cityId=" + data)
      .then((res) => {
        commit("setRegions", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getPersons({ dispatch, commit }, data) {
    axios
      .get("base/api/v1/DropDown/Persons?" + data)
      .then((res) => {
        commit("setPersons", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getPersonTypes({ dispatch, commit }) {
    axios
      .get("base/api/v1/dropDown/personTypes")
      .then((res) => {
        commit("setPersonTypes", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getPrefixes({ dispatch, commit }) {
    axios
      .get("base/api/v1/DropDown/Prefixes")
      .then((res) => {
        commit("setPrefixes", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getPersonGroups({ dispatch, commit }, data) {
    axios
      .get("base/api/v1/dropDown/PersonGroups?" + data)
      .then((res) => {
        commit("setPersonGroups", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getPersonBranches({ dispatch, commit }, data) {
    axios
      .get("base/api/v1/DropDown/PersonBranches?branchId=" + data)
      .then((res) => {
        commit("setPersonBranches", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getPersonPositions({ dispatch, commit }) {
    axios
      .get("base/api/v1/DropDown/PositionInformation")
      .then((res) => {
        commit("setPositionInformation", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getMaritalStatuses({ dispatch, commit }) {
    axios
      .get("base/api/v1/dropDown/maritalStatuses")
      .then((res) => {
        commit("setMaritalStatuses", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getSbus({ dispatch, commit }) {
    axios
      .get("base/api/v1/DropDown/Sbus")
      .then((res) => {
        commit("setSbus", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getUserGroups({ dispatch, commit }) {
    axios
      .get("base/api/v1/DropDown/DataGroups")
      .then((res) => {
        commit("setUserGroups", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getBranchFiscalYears({ dispatch, commit }, data) {
    axios
      .get("base/api/v1/DropDown/FiscalYears/" + data)
      .then((res) => {
        commit("setBranchFiscalYears", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getFiscalYearsById({ dispatch, commit }, data) {
    axios
      .get("base/api/v1/DropDown/FiscalYear/" + data)
      .then((res) => {
        commit("setFiscalYearById", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getPermissions({ dispatch, commit }, data) {
    axios
      .get("base/api/v1/DropDown/Permissions?" + data)
      .then((res) => {
        commit("setPermissions", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  // Promise برمی‌گرداند تا گارد روتر بتواند تا آمدن لیست منتظر بماند
  getCompanySubSystems({ dispatch, commit, state }, force = false) {
    if (!force && state.companySubSystemsLoaded) return Promise.resolve();
    if (companySubSystemsRequest) return companySubSystemsRequest;

    companySubSystemsRequest = axios
      .get("base/api/v1/DropDown/CompanySubSystems")
      .then((res) => {
        commit("setCompanySubSystems", res.data.data);
      })
      .catch((error) => {
        // این درخواست داخل گارد روتر اجرا می‌شود؛ errorGETHandler در خطای ۴۰۳
        // به صٝحه Page403 push می‌کند و ناوبری در حال انجام را خراب می‌کند.
        // پس ٝقط ۴۰۱ (انقضای توکن) مدیریت می‌شود و بقیه خطاها بی‌صدا رد می‌شوند.
        const status = error && error.response && error.response.status;
        if (status === 401) dispatch("logout", null, { root: true });
        // در صورت خطا لیست «بارگذاری‌شده» علامت نمی‌خورد تا دٝعه بعد
        // دوباره تلاش شود و کاربر پشت صٝحه قٝل گیر نکند.
      })
      .finally(() => {
        companySubSystemsRequest = null;
      });

    return companySubSystemsRequest;
  },

  getSubTypes({ dispatch, commit }) {
    axios
      .get("base/api/v1/DropDown/SbuTypes")
      .then((res) => {
        commit("setSbuTypes", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getFloatAccounts({ dispatch, commit }, data) {
    axios
      .get("base/api/v1/DropDown/FloatAccounts?" + data)
      .then((res) => {
        commit("setFloatAccounts", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getFloatAccountTypes({ dispatch, commit }) {
    axios
      .get("base/api/v1/DropDown/FloatAccountTypes")
      .then((res) => {
        commit("setFloatAccountTypes", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getFloatAccountGroups({ dispatch, commit }, data) {
    axios
      .get("base/api/v1/DropDown/FloatAccountGroups?" + data)
      .then((res) => {
        commit("setFloatAccountGroups", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getFloatAccountGroups1({ dispatch, commit }) {
    axios
      .get("base/api/v1/DropDown/FloatAccountGroups?floatAccountTypeId=1")
      .then((res) => {
        commit("setFloatAccountGroups1", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getFloatAccountGroups2({ dispatch, commit }) {
    axios
      .get("base/api/v1/DropDown/FloatAccountGroups?floatAccountTypeId=2")
      .then((res) => {
        commit("setFloatAccountGroups2", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getFloatAccountGroups3({ dispatch, commit }) {
    axios
      .get("base/api/v1/DropDown/FloatAccountGroups?floatAccountTypeId=3")
      .then((res) => {
        commit("setFloatAccountGroups3", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getFloatAccountGroups4({ dispatch, commit }) {
    axios
      .get("base/api/v1/DropDown/FloatAccountGroups?floatAccountTypeId=4")
      .then((res) => {
        commit("setFloatAccountGroups4", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getFloatAccountGroups5({ dispatch, commit }) {
    axios
      .get("base/api/v1/DropDown/FloatAccountGroups?floatAccountTypeId=5")
      .then((res) => {
        commit("setFloatAccountGroups5", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getGender({ dispatch, commit }) {
    axios
      .get("base/api/v1/DropDown/Genders")
      .then((res) => {
        commit("setGender", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getInvoiceTypes({ dispatch, commit }) {
    axios
      .get("base/api/v1/DropDown/InvoiceTypes")
      .then((res) => {
        commit("setInvoiceTypes", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getPersonGrades({ dispatch, commit }) {
    axios
      .get("base/api/v1/DropDown/PersonGrades")
      .then((res) => {
        commit("setPersonGrades", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getDataOperations({ dispatch, commit }) {
    axios
      .get("base/api/v1/DropDown/DataOperations")
      .then((res) => {
        commit("setDataOperations", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getDataUsers({ dispatch, commit }) {
    axios
      .get("base/api/v1/DropDown/Users")
      .then((res) => {
        commit("setDataUsers", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  // پرامیس برگردانده می‌شود تا صٝحه‌هایی که ستون‌های گریدشان به این پیکربندی
  // وابسته است بتوانند تا آماده‌شدن آن صبر کنند
  getFloatAccountConfigs({ dispatch, commit }) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    return axios
      .get("base/api/v1/DropDown/FloatAccountConfigs")
      .then((res) => {
        commit("setFloatAccountConfigs", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getFloatAccounts1({ dispatch, commit }) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .get("base/api/v1/DropDown/FloatAccounts?floatAccountTypeId=1")
      .then((res) => {
        commit("setFloatAccounts1", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getFloatAccounts2({ dispatch, commit }) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .get("base/api/v1/DropDown/FloatAccounts?floatAccountTypeId=2")
      .then((res) => {
        commit("setFloatAccounts2", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getFloatAccounts3({ dispatch, commit }) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .get("base/api/v1/DropDown/FloatAccounts?floatAccountTypeId=3")
      .then((res) => {
        commit("setFloatAccounts3", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getFloatAccounts4({ dispatch, commit }) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .get("base/api/v1/DropDown/FloatAccounts?floatAccountTypeId=4")
      .then((res) => {
        commit("setFloatAccounts4", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getFloatAccounts5({ dispatch, commit }) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .get("base/api/v1/DropDown/FloatAccounts?floatAccountTypeId=5")
      .then((res) => {
        commit("setFloatAccounts5", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getSuppliers({ dispatch, commit }) {
    axios
      .get("base/api/v1/DropDown/Suppliers")
      .then((res) => {
        commit("setSuppliers", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getCashiers({ dispatch, commit }, data) {
    axios
      .get("base/api/v1/DropDown/Cashiers?ids=" + data)
      .then((res) => {
        commit("setCashiers", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getBuyers({ dispatch, commit }) {
    axios
      .get("base/api/v1/DropDown/Buyers")
      .then((res) => {
        commit("setBuyers", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getReceivers({ dispatch, commit }) {
    axios
      .get("base/api/v1/DropDown/Receivers")
      .then((res) => {
        commit("setReceivers", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getSbuTree({ dispatch, commit }) {
    axios
      .get("base/api/v1/DropDown/SbuTree")
      .then((res) => {
        commit("setSbuTree", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getPositionInfoTree({ dispatch, commit }) {
    axios
      .get("base/api/v1/DropDown/PositionInformationTree")
      .then((res) => {
        commit("setPositionInfoTree", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getCartable({ dispatch, commit }) {
    axios
      .get("base/api/v1/DropDown/Cartables")
      .then((res) => {
        commit("setCartable", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getVehicleTypes({ dispatch, commit }) {
    axios
      .get("base/api/v1/DropDown/VehicleType")
      .then((res) => {
        commit("setVehicleTypes", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getCurrencyTypes({ dispatch, commit }) {
    axios
      .get("base/api/v1/DropDown/currencyTypes")
      .then((res) => {
        commit("setCurrencyTypes", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getSmsTypes({ dispatch, commit }) {
    axios
      .get("Notify/api/v1/DropDown/SmsTypes")
      .then((res) => {
        commit("setSmsTypes", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
  getTransactionInfo({ dispatch, commit }, data) {
    axios
      .get("base/api/v1/DropDown/TransactionInfo?" + data)
      .then((res) => {
        commit("setTransactionInfo", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getDateTypes({ dispatch, commit }) {
    axios
      .get("base/api/v1/DropDown/DateTypes")
      .then((res) => {
        commit("setDateTypes", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getCrmDateTypes({ dispatch, commit }) {
    axios
      .get("base/api/v1/DropDown/DateTypes")
      .then((res) => {
        commit("setDateTypes", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getSettingDropdown({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .get(data)
      .then((res) => {
        commit("setSettingDropdownCache", { path: data, data: res.data.data });
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })

      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getListSetting({ dispatch, commit }) {
    axios
      .get("base/api/v1/DropDown/ListSetting")
      .then((res) => {
        commit("setListSetting", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getAddMinusType({ dispatch, commit }) {
    axios
      .get("base/api/v1/DropDown/AddMinusTypes")
      .then((res) => {
        commit("setAddMinusType", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getSaleAddMinuses({ dispatch, commit }) {
    axios
      .get("base/api/v1/DropDown/SaleAddMinuses")
      .then((res) => {
        commit("setSaleAddMinuses", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getDocumentTypes({ dispatch, commit }) {
    axios
      .get("base/api/v1/DropDown/DocumentTypes")
      .then((res) => {
        commit("setDocumentTypes", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getBuyAddMinuses({ dispatch, commit }) {
    axios
      .get("base/api/v1/DropDown/BuyAddMinuses")
      .then((res) => {
        commit("setBuyAddMinuses", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getBanks({ dispatch, commit }) {
    axios
      .get("base/api/v1/DropDown/Bank")
      .then((res) => {
        commit("setBanks", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getBankBranchs({ dispatch, commit }, data) {
    axios
      .get("base/api/v1/DropDown/BankBranch?bankId=" + data)
      .then((res) => {
        commit("setBankBranchs", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getSalesManagers({ dispatch, commit }) {
    axios
      .get("base/api/v1/dropDown/SalesManagers")
      .then((res) => {
        commit("setSalesManagers", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getPurchaseManagers({ dispatch, commit }) {
    axios
      .get("base/api/v1/DropDown/PurchaseManagers")
      .then((res) => {
        commit("setPurchaseManagers", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  // getDistributors({ dispatch, commit }) {
  //   axios
  //     .get("base/api/v1/base/dropDown/Distributors")
  //     .then((res) => {
  //       commit("setDistributors", res.data.data);
  //     })
  //     .catch((error) => {
  //       dispatch("errorGETHandler", error, { root: true });
  //     });
  // },

  getDrivers({ dispatch, commit }) {
    axios
      .get("base/api/v1/base/dropDown/Drivers")
      .then((res) => {
        commit("setDrivers", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getSellers({ dispatch, commit }) {
    axios
      .get("base/api/v1/dropDown/Sellers")
      .then((res) => {
        commit("setSellers", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getContractors({ dispatch, commit }) {
    axios
      .get("base/api/v1/DropDown/Contractors")
      .then((res) => {
        commit("setContractors", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  // getEmployers({ dispatch, commit }) {
  //   axios
  //     .get("base/api/v1/dropDown/Employers")
  //     .then((res) => {
  //       commit("setEmployers", res.data.data);
  //     })
  //     .catch((error) => {
  //       dispatch("errorGETHandler", error, { root: true });
  //     });
  // },

  getEmployees({ dispatch, commit }) {
    axios
      .get("base/api/v1/dropDown/Employees")
      .then((res) => {
        commit("setEmployees", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getPersonAddress({ dispatch, commit }, data) {
    axios
      .get("base/api/v1/PersonAddress?personId=" + data)
      .then((res) => {
        commit("setPersonAddress", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getReceiptCartableConfirm({ dispatch, commit }) {
    axios
      .get("base/api/v1/DropDown/ReceiptFinalizationCartableConfirms")
      .then((res) => {
        commit("setReceiptCartableConfirm", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getDraftCartableConfirm({ dispatch, commit }) {
    axios
      .get("base/api/v1/DropDown/DraftFinalizationCartableConfirms")
      .then((res) => {
        commit("setDraftCartableConfirm", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getSaleCartableConfirm({ dispatch, commit }) {
    axios
      .get("base/api/v1/DropDown/SalesFactorCartableConfirms")
      .then((res) => {
        commit("setSaleCartableConfirm", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getSalesReturnCartableConfirm({ dispatch, commit }) {
    axios
      .get("base/api/v1/DropDown/SalesReturnFactorCartableConfirms")
      .then((res) => {
        commit("setSalesReturnCartableConfirm", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getBuyFactorCartableConfirm({ dispatch, commit }) {
    axios
      .get("base/api/v1/DropDown/BuyFactorCartableConfirms")
      .then((res) => {
        commit("setBuyFactorCartableConfirm", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getBuyReturnCartableConfirm({ dispatch, commit }) {
    axios
      .get("base/api/v1/DropDown/BuyReturnFactorCartableConfirms")
      .then((res) => {
        commit("setBuyReturnCartableConfirm", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getReqBuyCartableConfirm({ dispatch, commit }) {
    axios
      .get("base/api/v1/DropDown/BuyRequestCartableConfirms")
      .then((res) => {
        commit("setReqBuyCartableConfirm", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getReqPaymentCartableConfirm({ dispatch, commit }) {
    axios
      .get("base/api/v1/DropDown/PaymentRequestCartableConfirms")
      .then((res) => {
        commit("setReqPaymentCartableConfirm", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getChequePaymentCartableConfirm({ dispatch, commit }) {
    axios
      .get("base/api/v1/DropDown/ChequePaymentCartableConfirms")
      .then((res) => {
        commit("setChequePaymentCartableConfirm", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getReceiveChequeCartableConfirm({ dispatch, commit }) {
    axios
      .get("base/api/v1/DropDown/ChequeReceiptCartableConfirms")
      .then((res) => {
        commit("setReceiveChequeCartableConfirm", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getDateTimeFormats({ dispatch, commit }) {
    axios
      .get("base/api/v1/DropDown/DateTimeFormat")
      .then((res) => {
        commit("setDateTimeFormats", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getDecreaseSaleAddMinuses({ dispatch, commit }) {
    axios
      .get("base/api/v1/DropDown/DecreaseSaleAddMinuses")
      .then((res) => {
        commit("setDecreaseSaleAddMinuses", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getVoucherTemplateKeyType({ dispatch, commit }, data) {
    axios
      .get(
        "base/api/v1/DropDown/VoucherTemplateKeyTypeEnum" +
          (data ? "?" + data : ""),
      )
      .then((res) => {
        commit("setVoucherTemplateKeyType", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getUnitCount({ dispatch, commit }) {
    axios
      .get("base/api/v1/DropDown/UnitCount")
      .then((res) => {
        commit("setUnitCount", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getAdvanceCartableConfirm({ dispatch, commit }) {
    axios
      .get("base/api/v1/DropDown/AdvanceCartableConfirms")
      .then((res) => {
        commit("setAdvanceCartableConfirm", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getOrderCartableConfirm({ dispatch, commit }) {
    axios
      .get("base/api/v1/DropDown/OrderCartableConfirms")
      .then((res) => {
        commit("setOrderCartableConfirm", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getLeaveCartableConfirm({ dispatch, commit }) {
    axios
      .get("base/api/v1/DropDown/LeaveCartableConfirms")
      .then((res) => {
        commit("setLeaveCartableConfirm", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getStudyFieldTypes({ dispatch, commit }) {
    axios
      .get("base/api/v1/DropDown/StudyFieldTypes")
      .then((res) => {
        commit("setStudyFieldTypes", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getDegreeTypes({ dispatch, commit }) {
    axios
      .get("base/api/v1/DropDown/DegreeTypes")
      .then((res) => {
        commit("setDegreeTypes", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getEmploymentType({ dispatch, commit }) {
    axios
      .get("base/api/v1/DropDown/EmploymentTypes")
      .then((res) => {
        commit("setEmploymentType", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getInsuranceTypes({ dispatch, commit }) {
    axios
      .get("base/api/v1/DropDown/InsuranceTypes")
      .then((res) => {
        commit("setInsuranceTypes", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getServiceStatuses({ dispatch, commit }) {
    axios
      .get("base/api/v1/DropDown/ServiceStatuses")
      .then((res) => {
        commit("setServiceStatuses", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getNationalityTypes({ dispatch, commit }) {
    axios
      .get("base/api/v1/DropDown/NationalityTypes")
      .then((res) => {
        commit("setNationalityTypes", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getOccupationCategories({ dispatch, commit }) {
    axios
      .get("base/api/v1/DropDown/OccupationCategories")
      .then((res) => {
        commit("setOccupationCategories", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getTaxVehicles({ dispatch, commit }) {
    axios
      .get("base/api/v1/DropDown/TaxVehicles")
      .then((res) => {
        commit("setTaxVehicles", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getTaxHousings({ dispatch, commit }) {
    axios
      .get("base/api/v1/DropDown/TaxHousing")
      .then((res) => {
        commit("setTaxHousings", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getEmploymentTypes({ dispatch, commit }) {
    axios
      .get("base/api/v1/DropDown/EmploymentTypes")
      .then((res) => {
        commit("setEmploymentTypes", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getDepartments({ dispatch, commit }) {
    axios
      .get("base/api/v1/DropDown/Departments")
      .then((res) => {
        commit("setDepartments", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getPersonnels({ dispatch, commit }) {
    axios
      .get("base/api/v1/DropDown/Personnel")
      .then((res) => {
        commit("setPersonnels", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getUnits({ dispatch, commit }) {
    axios
      .get("base/api/v1/DropDown/UnitCount")
      .then((res) => {
        commit("setUnits", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getVoucherTemplateType({ dispatch, commit }, data) {
    axios
      .get("base/api/v1/DropDown/VoucherTemplateEnumType?" + data)
      .then((res) => {
        commit("setVoucherTemplateType", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getManagementCartable({ dispatch, commit }, data) {
    axios
      .get("base/api/v1/DropDown/ManagementCartable?cartableId=" + data)
      .then((res) => {
        commit("setManagementCartable", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getReportDropDown({ dispatch, commit }, data) {
    axios
      .get("base/api/v1/DropDown/Report?" + data)
      .then((res) => {
        commit("setReportDropDown", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getFinancialSystemTypes({ dispatch, commit }) {
    axios
      .get("base/api/v1/DropDown/FinancialSystemTypes")
      .then((res) => {
        commit("setFinancialSystemTypes", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  // PSPLY DropDowns  -----------------------------------------------
  getCommodities({ dispatch, commit, state }, data) {
    if (!state.companySubSystems?.some((x) => x.subSystemId == 24)) {
      commit("setCommodities", []);
      return;
    }
    return axios
      .get("sply/api/v1/DropDown/Commodity" + data)
      .then((res) => {
        commit("setCommodities", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandlerSilent", error, { root: true });
      });
  },

  getCommoditiesCirculation({ dispatch, commit }) {
    axios
      .get("sply/api/v1/DropDown/Commodity?isCirculation=true")
      .then((res) => {
        commit("setCommodities", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getWares({ dispatch, commit }) {
    axios
      .get("sply/api/v1/DropDown/WareInfo")
      .then((res) => {
        commit("setWares", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getWareShelfInfos({ dispatch, commit }, data) {
    axios
      .get("sply/api/v1/DropDown/WareShelfInfo" + (data ? "?" + data : ""))
      .then((res) => {
        commit("setWareShelfInfos", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getWareShelfInfos2({ dispatch, commit }, data) {
    axios
      .get("sply/api/v1/DropDown/WareShelfInfo" + (data ? "?" + data : ""))
      .then((res) => {
        commit("setWareShelfInfos2", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getOrdrSettlementTypes({ dispatch, commit }) {
    axios
      .get("sale/api/v1/basic/ordr/SettlementType/DropDown")
      .then((res) => {
        commit("setOrdrSettlementTypes", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getWaresWithoutLimit({ dispatch, commit }) {
    axios
      .get("sply/api/v1/DropDown/WareInfoWithoutLimit")
      .then((res) => {
        commit("setWaresWithoutLimit", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getWareCategories({ dispatch, commit }) {
    axios
      .get("sply/api/v1/DropDown/WareCategory")
      .then((res) => {
        commit("setWareCategories", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getAdditionalCommodityParamenterTypes({ dispatch, commit }) {
    axios
      .get("sply/api/v1/DropDown/AdditionalCommodityParameterType")
      .then((res) => {
        commit("setAdditionalCommodityParamenterTypes", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getFiledTypes({ dispatch, commit }) {
    axios
      .get("sply/api/v1/DropDown/FiledTypeEnum")
      .then((res) => {
        commit("setFiledTypes", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  // انواع سند رسید (رسید دائم)
  getReceiptWareVoucherType({ dispatch, commit }) {
    axios
      .get(
        "sply/api/v1/DropDown/WareVoucherType?IsReceipt=true&IsTemporery=false",
      )
      .then((res) => {
        commit("setReceiptWareVoucherTypes", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  // انواع سند حواله
  getDraftWareVoucherType({ dispatch, commit }) {
    axios
      .get("sply/api/v1/DropDown/WareVoucherType?IsReceipt=false")
      .then((res) => {
        commit("setDraftWareVoucherType", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  // انواع سند رسید موقت
  getTempReceiptWareVoucherType({ dispatch, commit }) {
    axios
      .get(
        "sply/api/v1/DropDown/WareVoucherType?IsReceipt=true&IsTemporery=true",
      )
      .then((res) => {
        commit("setTempReceiptWareVoucherTypes", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getCommodityGroups({ dispatch, commit }) {
    axios
      .get("sply/api/v1/DropDown/CommodityGroup")
      .then((res) => {
        commit("setCommodityGroups", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getWareVoucherTypes({ dispatch, commit }) {
    axios
      .get("sply/api/v1/DropDown/WareVoucherEnum")
      .then((res) => {
        commit("setWareVoucherTypes", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  // مثل getFloatAccountConfigs، پرامیس برگردانده می‌شود
  getAdditionalCommodityParameters({ dispatch, commit }) {
    commit("setLoadingBtn", true, { root: true });
    return axios
      .get("sply/api/v1/DropDown/AdditionalCommodityParameters")
      .then((res) => {
        commit("setAdditionalCommodityParameters", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getWareCommodities({ dispatch, commit }, data) {
    axios
      .get("sply/api/v1/DropDown/WareCommodity/" + data)
      .then((res) => {
        commit("setWareCommodities", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getDestinationWareCommodities({ dispatch, commit }, data) {
    axios
      .get("sply/api/v1/DropDown/WareCommodity/" + data)
      .then((res) => {
        commit("setDestinationWareCommodities", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getDrafts({ dispatch, commit }) {
    axios
      .get("sply/api/v1/DropDown/Drafts")
      .then((res) => {
        commit("setDrafts", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getCommodityUnitCounts({ dispatch, commit }, data) {
    axios
      .get("sply/api/v1/DropDown/CommodityUnitCounts?commodityId=" + data)
      .then((res) => {
        commit("setCommodityUnitCounts", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getCommodityParameters({ dispatch, commit }, data) {
    axios
      .get("sply/api/v1/DropDown/CommodityParameter?commodityId=" + data)
      .then((res) => {
        commit("setCommodityParameters", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getCommodityBatches({ dispatch, commit }, data) {
    axios
      .get("sply/api/v1/DropDown/CommodityBatches?commodityId=" + data)
      .then((res) => {
        commit("setCommodityBatches", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getItemGroupTree({ dispatch, commit }, data) {
    axios
      .get("Sply/api/v1/DropDown/ItemGroupTree?" + data)
      .then((res) => {
        commit("setItemGroupTree", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getBuyRequests({ dispatch, commit }) {
    axios
      .get("sply/api/v1/DropDown/ReqBuy")
      .then((res) => {
        commit("setBuyRequests", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getWarehousingTypes({ dispatch, commit }) {
    axios
      .get("sply/api/v1/DropDown/WarehousingTypes")
      .then((res) => {
        commit("setWarehousingTypes", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getTempReceipts({ dispatch, commit }) {
    axios
      .get("sply/api/v1/DropDown/TempReceipts")
      .then((res) => {
        commit("setTempReceipts", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getPackageTypes({ dispatch, commit }) {
    axios
      .get("sply/api/v1/DropDown/PackageTypes")
      .then((res) => {
        commit("setPackageTypes", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getReceipts({ dispatch, commit }) {
    axios
      .get("sply/api/v1/DropDown/Receipts")
      .then((res) => {
        commit("setReceipts", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getBuyFactorTypes({ dispatch, commit }) {
    axios
      .get("sply/api/v1/DropDown/BuyFactorTypes")
      .then((res) => {
        commit("setBuyFactorTypes", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getScmsBuyTypes({ dispatch, commit }) {
    axios
      .get("sply/api/v1/DropDown/BuyTypes")
      .then((res) => {
        commit("setScmsBuyTypes", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getReturnBuyFactors({ dispatch, commit }) {
    axios
      .get("sply/api/v1/DropDown/ReturnBuyFactors")
      .then((res) => {
        commit("setReturnBuyFactors", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getTransferCommodites({ dispatch, commit }) {
    axios
      .get("sply/api/v1/DropDown/TransferCommodites")
      .then((res) => {
        commit("setTransferCommodites", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getWarehousings({ dispatch, commit }) {
    axios
      .get("sply/api/v1/DropDown/Warehousing")
      .then((res) => {
        commit("setWarehousings", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getBuyFactors({ dispatch, commit }) {
    axios
      .get("sply/api/v1/DropDown/BuyFactors")
      .then((res) => {
        commit("setBuyFactors", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  // PFINC DropDowns  -----------------------------------------------
  getCurrentPersonInVoucherDetails({ dispatch, commit, state }) {
    if (!state.companySubSystems?.some((x) => x.subSystemId == 11)) {
      return;
    }
    axios
      .get("finc/api/v1/dropDown/CurrentPersonInVoucherDetails")
      .then((res) => {
        commit("setCurrentPersonInVoucherDetails", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getAccountInfos1({ dispatch, commit, state }) {
    if (!state.companySubSystems?.some((x) => x.subSystemId == 11)) {
      return;
    }
    axios
      .get("finc/api/v1/dropDown/AccountInfos")
      .then((res) => {
        commit("setAccountInfos", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getAccountInfos({ dispatch, commit, state }, data) {
    if (!state.companySubSystems?.some((x) => x.subSystemId == 11)) {
      return;
    }
    axios
      .get(
        "finc/api/v1/dropDown/AccountInfos?isLastNode=true&AccountRootId=" +
          data,
      )
      .then((res) => {
        commit("setAccountInfos", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getAccountTypes({ dispatch, commit, state }) {
    if (!state.companySubSystems?.some((x) => x.subSystemId == 11)) {
      return;
    }
    axios
      .get("finc/api/v1/DropDown/AccountTypes")
      .then((res) => {
        commit("setAccountTypes", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getAccountControls({ dispatch, commit, state }) {
    if (!state.companySubSystems?.some((x) => x.subSystemId == 11)) {
      return;
    }
    axios
      .get("finc/api/v1/DropDown/AccountControls")
      .then((res) => {
        commit("setAccountControls", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getAccountActions({ dispatch, commit, state }) {
    if (!state.companySubSystems?.some((x) => x.subSystemId == 11)) {
      return;
    }
    axios
      .get("finc/api/v1/DropDown/AccountActions")
      .then((res) => {
        commit("setAccountActions", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getVoucherNoteTypes({ dispatch, commit, state }) {
    if (!state.companySubSystems?.some((x) => x.subSystemId == 11)) {
      return;
    }
    axios
      .get("finc/api/v1/DropDown/VoucherNoteTypes")
      .then((res) => {
        commit("setVoucherNoteTypes", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getDefaultVoucherDescriptions({ dispatch, commit, state }) {
    if (!state.companySubSystems?.some((x) => x.subSystemId == 11)) {
      return;
    }
    axios
      .get("finc/api/v1/DropDown/DefaultVoucherDescriptions")
      .then((res) => {
        commit("setDefaultVoucherDescriptions", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getVouchers({ dispatch, commit, state }) {
    if (!state.companySubSystems?.some((x) => x.subSystemId == 11)) {
      return;
    }
    axios
      .get("finc/api/v1/DropDown/Vouchers")
      .then((res) => {
        commit("setVouchers", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getReportVouchers({ dispatch, commit, state }, data) {
    if (!state.companySubSystems?.some((x) => x.subSystemId == 11)) {
      return;
    }
    axios
      .get("finc/api/v1/DropDown/ReportVouchers?IsIncludePreviousYear=" + data)
      .then((res) => {
        commit("setReportVouchers", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getTurnTypes({ dispatch, commit, state }) {
    if (!state.companySubSystems?.some((x) => x.subSystemId == 11)) {
      return;
    }
    axios
      .get("finc/api/v1/DropDown/LoadTurnType")
      .then((res) => {
        commit("setTurnTypes", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getChequeStatusTypes({ dispatch, commit, state }) {
    if (!state.companySubSystems?.some((x) => x.subSystemId == 11)) {
      return;
    }
    axios
      .get("finc/api/v1/DropDown/LoadChequeStatusType")
      .then((res) => {
        commit("setChequeStatusTypes", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getChequeTemplates({ dispatch, commit, state }) {
    if (!state.companySubSystems?.some((x) => x.subSystemId == 11)) {
      return;
    }
    axios
      .get("finc/api/v1/DropDown/LoadChequeTemplates")
      .then((res) => {
        commit("setChequeTemplates", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getBankCashAccount({ dispatch, commit, state }, data) {
    if (!state.companySubSystems?.some((x) => x.subSystemId == 11)) {
      return;
    }
    axios
      .get("finc/api/v1/DropDown/BankCashAccount?isAccount=" + data)
      .then((res) => {
        commit("setBankCashAccount", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getRequestType({ dispatch, commit, state }) {
    if (!state.companySubSystems?.some((x) => x.subSystemId == 11)) {
      return;
    }
    axios
      .get("finc/api/v1/DropDown/RequestTypes")
      .then((res) => {
        commit("setRequestType", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getChequeStatuses({ dispatch, commit, state }, data) {
    if (!state.companySubSystems?.some((x) => x.subSystemId == 11)) {
      return;
    }
    axios
      .get("finc/api/v1/DropDown/LoadAllChequeStatus?" + data)
      .then((res) => {
        commit("setChequeStatuses", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getFinancialRatios({ dispatch, commit, state }) {
    if (!state.companySubSystems?.some((x) => x.subSystemId == 11)) {
      return;
    }
    axios
      .get("finc/api/v1/DropDown/FinancialRatios")
      .then((res) => {
        commit("setFinancialRatios", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getRequestPayment({ dispatch, commit, state }, data) {
    if (!state.companySubSystems?.some((x) => x.subSystemId == 11)) {
      return;
    }
    axios
      .get("finc/api/v1/DropDown/RequestPayment?" + data)
      .then((res) => {
        commit("setRequestPayment", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getChequeBatches({ dispatch, commit, state }, data) {
    if (!state.companySubSystems?.some((x) => x.subSystemId == 11)) {
      return;
    }
    axios
      .get("finc/api/v1/DropDown/ChequeBatchDetailByChequeNumber" + data)
      .then((res) => {
        commit("setChequeBatches", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getReceiveChequeFilters({ dispatch, commit, state }) {
    if (!state.companySubSystems?.some((x) => x.subSystemId == 11)) {
      return;
    }
    axios
      .get("finc/api/v1/DropDown/LoadReceiveChequeFilters")
      .then((res) => {
        commit("setReceiveChequeFilters", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getPaymentChequeFilters({ dispatch, commit, state }) {
    if (!state.companySubSystems?.some((x) => x.subSystemId == 11)) {
      return;
    }
    axios
      .get("finc/api/v1/DropDown/LoadPaymentChequeFilters")
      .then((res) => {
        commit("setPaymentChequeFilters", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getMonthlyComparisonReceiveChequeFilters({ dispatch, commit, state }) {
    if (!state.companySubSystems?.some((x) => x.subSystemId == 11)) {
      return;
    }
    axios
      .get("finc/api/v1/DropDown/LoadMonthlyComparisonReceiveChequeFilters")
      .then((res) => {
        commit("setMonthlyComparisonReceiveChequeFilters", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getMonthlyComparisonPaymentChequeFilters({ dispatch, commit, state }) {
    if (!state.companySubSystems?.some((x) => x.subSystemId == 11)) {
      return;
    }
    axios
      .get("finc/api/v1/DropDown/LoadMonthlyComparisonPaymentChequeFilters")
      .then((res) => {
        commit("setMonthlyComparisonPaymentChequeFilters", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getSummaryPaymentChequeFilters({ dispatch, commit, state }) {
    if (!state.companySubSystems?.some((x) => x.subSystemId == 11)) {
      return;
    }
    axios
      .get("finc/api/v1/DropDown/LoadSummaryPaymentChequeFilters")
      .then((res) => {
        commit("setSummaryPaymentChequeFilters", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getSummaryReceiveChequeFilters({ dispatch, commit, state }) {
    if (!state.companySubSystems?.some((x) => x.subSystemId == 11)) {
      return;
    }
    axios
      .get("finc/api/v1/DropDown/LoadSummaryReceiveChequeFilters")
      .then((res) => {
        commit("setSummaryReceiveChequeFilters", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getReceiveAndPay({ dispatch, commit, state }, data) {
    if (!state.companySubSystems?.some((x) => x.subSystemId == 11)) {
      return;
    }
    axios
      .get("finc/api/v1/DropDown/ReceiptPaymentDropDown?typeId=" + data)
      .then((res) => {
        commit("setReceiveAndPay", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getAccountConfigs({ dispatch, commit, state }, data) {
    if (!state.companySubSystems?.some((x) => x.subSystemId == 11)) {
      return;
    }
    axios
      .get("finc/api/v1/DropDown/AccountConfigs" + data)
      .then((res) => {
        commit("setAccountConfigs", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getSearchTypes({ dispatch, commit, state }) {
    if (!state.companySubSystems?.some((x) => x.subSystemId == 11)) {
      return;
    }
    axios
      .get("finc/api/v1/DropDown/SearchTypes")
      .then((res) => {
        commit("setSearchTypes", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getSaltDateTypes({ dispatch, commit, state }) {
    if (!state.companySubSystems?.some((x) => x.subSystemId == 11)) {
      return;
    }
    axios
      .get("finc/api/v1/DropDown/SaltDateTypes")
      .then((res) => {
        commit("setSaltDateTypes", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getTransactionTypes({ dispatch, commit, state }) {
    if (!state.companySubSystems?.some((x) => x.subSystemId == 11)) {
      return;
    }
    axios
      .get("finc/api/v1/DropDown/TransactionTypes")
      .then((res) => {
        commit("setTransactionTypes", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getPersonOfficeReportTypes({ dispatch, commit, state }) {
    if (!state.companySubSystems?.some((x) => x.subSystemId == 11)) {
      return;
    }
    axios
      .get("finc/api/v1/DropDown/PersonOfficeReportTypes")
      .then((res) => {
        commit("setPersonOfficeReportTypes", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getMonthlyAccountingVoucherKeyTypes({ dispatch, commit, state }) {
    if (!state.companySubSystems?.some((x) => x.subSystemId == 11)) {
      return;
    }
    axios
      .get("finc/api/v1/DropDown/MonthlyAccountingVoucherKeyTypes")
      .then((res) => {
        commit("setMonthlyAccountingVoucherKeyTypes", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getTurnTypeReceived({ dispatch, commit, state }) {
    if (!state.companySubSystems?.some((x) => x.subSystemId == 11)) {
      return;
    }
    axios
      .get("finc/api/v1/DropDown/LoadTurnTypeReceived")
      .then((res) => {
        commit("setTurnTypeReceived", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getTurnTypePayable({ dispatch, commit, state }) {
    if (!state.companySubSystems?.some((x) => x.subSystemId == 11)) {
      return;
    }
    axios
      .get("finc/api/v1/DropDown/LoadTurnTypePayable")
      .then((res) => {
        commit("setTurnTypePayable", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getTurnCashTypes({ dispatch, commit, state }) {
    if (!state.companySubSystems?.some((x) => x.subSystemId == 11)) {
      return;
    }
    axios
      .get("finc/api/v1/DropDown/TurnCashTypeEnum")
      .then((res) => {
        commit("setTurnCashTypes", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getIssueTrackingTypes({ dispatch, commit, state }) {
    if (!state.companySubSystems?.some((x) => x.subSystemId == 11)) {
      return;
    }
    axios
      .get("finc/api/v1/DropDown/IssueTrackingType")
      .then((res) => {
        commit("setIssueTrackingTypes", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getTrackingNumbersByChequeNumber({ dispatch, commit, state }, data) {
    if (!state.companySubSystems?.some((x) => x.subSystemId == 11)) {
      return;
    }
    axios
      .get("finc/api/v1/DropDown/GetTrackingNumbersByChequeNumber?" + data)
      .then((res) => {
        commit("setTrackingNumbersByChequeNumber", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getReport({ dispatch, commit, state }, data) {
    if (!state.companySubSystems?.some((x) => x.subSystemId == 11)) {
      return;
    }
    axios
      .get("finc/api/v1/DropDown/GetReport?xml=" + data)
      .then((res) => {
        commit("setReport", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getExportFileFormatTypes({ dispatch, commit, state }) {
    if (!state.companySubSystems?.some((x) => x.subSystemId == 11)) {
      return;
    }
    axios
      .get("finc/api/v1/DropDown/ExportFileFormatTypes")
      .then((res) => {
        commit("setExportFileFormatTypes", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getReceiptPaymentSubjectTypes({ dispatch, commit, state }) {
    if (!state.companySubSystems?.some((x) => x.subSystemId == 11)) {
      return;
    }
    axios
      .get("finc/api/v1/DropDown/ReceiptPaymentSubjectTypes")
      .then((res) => {
        commit("setReceiptPaymentSubjectTypes", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getReceiptPaymentSubjects({ dispatch, commit, state }) {
    if (!state.companySubSystems?.some((x) => x.subSystemId == 11)) {
      return;
    }
    axios
      .get("finc/api/v1/DropDown/ReceiptPaymentSubjects")
      .then((res) => {
        commit("setReceiptPaymentSubjects", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getChequeSayadAndBankInfo({ dispatch, commit, state }, data) {
    if (!state.companySubSystems?.some((x) => x.subSystemId == 11)) {
      return;
    }
    axios
      .get("finc/api/v1/DropDown/GetChequeSayadAndBankInfo?" + data)
      .then((res) => {
        commit("setChequeSayadAndBankInfo", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: false });
      });
  },

  getVoucherSearchTypes({ dispatch, commit, state }) {
    if (!state.companySubSystems?.some((x) => x.subSystemId == 11)) {
      return;
    }
    axios
      .get("finc/api/v1/DropDown/VoucherSearchTypes")
      .then((res) => {
        commit("setVoucherSearchTypes", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
  getReceiveAndPayment({ commit, dispatch, state }, typeId) {
    if (!state.companySubSystems?.some((x) => x.subSystemId == 11)) {
      return;
    }
    axios
      .get(`finc/api/v1/DropDown/ReceiptPaymentDropDown?typeId=${typeId}`)
      .then((res) => {
        if (typeId === 1) {
          commit("setReceiveOptions", res.data?.data || []);
        } else if (typeId === 2) {
          commit("setPaymentOptions", res.data?.data || []);
        }
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getFloatAccountText({ dispatch, commit, state }, data) {
    if (!state.companySubSystems?.some((x) => x.subSystemId == 11)) {
      return;
    }
    commit("setLoadingBtn", true, { root: true });
    axios
      .get("finc/api/v1/DropDown/FloatAccountText" + data)
      .then((res) => {
        commit("setFloatAccountText", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getReviewVoucherAmountFilterTypes({ dispatch, commit, state }) {
    if (!state.companySubSystems?.some((x) => x.subSystemId == 11)) {
      return;
    }
    commit("setLoadingBtn", true, { root: true });
    axios
      .get("finc/api/v1/DropDown/ReviewVoucherAmountFilterTypes")
      .then((res) => {
        commit("setReviewVoucherAmountFilterTypes", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getPersonRecordingAccounts({ dispatch, commit, state }, data) {
    if (!state.companySubSystems?.some((x) => x.subSystemId == 11)) {
      return;
    }
    commit("setLoadingBtn", true, { root: true });
    axios
      .get("finc/api/v1/DropDown/PersonRecordingAccounts?" + data)
      .then((res) => {
        commit("setAccountInfos", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  // mrp2Al DropDowns  -----------------------------------------------
  getWorkStations({ dispatch, commit }) {
    axios
      .get("mrp2Al/api/v1/DropDown/WorkStations")
      .then((res) => {
        commit("setWorkStations", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getBoms({ dispatch, commit }) {
    axios
      .get("mrp2Al/api/v1/DropDown/Boms")
      .then((res) => {
        commit("setBoms", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getMRPProcessTypes({ dispatch, commit }, data) {
    axios
      .get("mrp2Al/api/v1/DropDown/ProcessTypes?" + data)
      .then((res) => {
        commit("setMRPProcessTypes", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getSubMRPProcessTypes({ dispatch, commit }, data) {
    axios
      .get("mrp2Al/api/v1/DropDown/ProcessTypes?" + data)
      .then((res) => {
        commit("setSubMRPProcessTypes", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getOrders({ dispatch, commit }) {
    axios
      .get("mrp2Al/api/v1/DropDown/Orders")
      .then((res) => {
        commit("setOrders", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getProduceOrderProcesses({ dispatch, commit }) {
    axios
      .get("mrp2Al/dropDown/produceOrderProcess")
      .then((res) => {
        commit("setProduceOrderProcesses", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getSprints({ dispatch, commit }) {
    axios
      .get("mrp2Al/api/v1/DropDown/Sprints")
      .then((res) => {
        commit("setSprints", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getProduceOrders({ dispatch, commit }, data) {
    axios
      .get("mrp2Al/api/v1/DropDown/ProduceOrders?" + data)
      .then((res) => {
        commit("setProduceOrders", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getCoilCertificates({ dispatch, commit }) {
    axios
      .get("mrp2Al/api/v1/DropDown/CoilCertificates")
      .then((res) => {
        commit("setCoilCertificates", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getCasterProduceOrders({ dispatch, commit }) {
    axios
      .get("mrp2Al/api/v1/DropDown/CasterProduceOrders")
      .then((res) => {
        commit("setCasterProduceOrders", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getProductionReports({ dispatch, commit }, data) {
    axios
      .get("mrp2Al/api/v1/DropDown/ProductionReports?processTypeId=" + data)
      .then((res) => {
        commit("setProductionReports", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getWorkStationStatuses({ dispatch, commit }) {
    axios
      .get("mrp2Al/api/v1/DropDown/WorkStationStatuses")
      .then((res) => {
        commit("setWorkStationStatuses", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getInputTypes({ dispatch, commit }) {
    axios
      .get("mrp2Al/api/v1/DropDown/inputTypes")
      .then((res) => {
        commit("setInputTypes", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getHardnesses({ dispatch, commit }) {
    axios
      .get("mrp2Al/api/v1/DropDown/Hardness")
      .then((res) => {
        commit("setHardnesses", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getProductSurfaces({ dispatch, commit }) {
    axios
      .get("mrp2Al/api/v1/DropDown/ProductSurface")
      .then((res) => {
        commit("setProductSurfaces", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getUsageGroups({ dispatch, commit }) {
    axios
      .get("mrp2Al/api/v1/DropDown/UsageGroup")
      .then((res) => {
        commit("setUsageGroups", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getFoilUsages({ dispatch, commit }) {
    axios
      .get("mrp2Al/api/v1/DropDown/FoilUsage")
      .then((res) => {
        commit("setFoilUsages", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getInnerCoreDiameters({ dispatch, commit }) {
    axios
      .get("mrp2Al/api/v1/DropDown/InnerCoreDiameter")
      .then((res) => {
        commit("setInnerCoreDiameters", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getWorkShifts({ dispatch, commit }) {
    axios
      .get("mrp2Al/api/v1/DropDown/WorkShifts")
      .then((res) => {
        commit("setWorkShifts", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getFurnaces({ dispatch, commit }) {
    axios
      .get("mrp2Al/api/v1/DropDown/Furnace")
      .then((res) => {
        commit("setFurnaces", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getFurnacePlacements({ dispatch, commit }, data) {
    axios
      .get("mrp2Al/api/v1/DropDown/FurnacePlacement?" + data)
      .then((res) => {
        commit("setFurnacePlacements", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getOrderDateTypes({ dispatch, commit }) {
    axios
      .get("mrp2Al/api/v1/DropDown/OrderDateType")
      .then((res) => {
        commit("setOrderDateTypes", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  // PSALE DropDowns  -----------------------------------------------
  getPersonClubGroups({ dispatch, commit, state }) {
    if (!state.companySubSystems?.some((x) => x.subSystemId == 19)) {
      return;
    }
    axios
      .get("sale/api/v1/DropDown/PersonClubGroups")
      .then((res) => {
        commit("setPersonClubGroups", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getPersonClubs({ dispatch, commit, state }) {
    if (!state.companySubSystems?.some((x) => x.subSystemId == 19)) {
      return;
    }
    axios
      .get("sale/api/v1/DropDown/PersonClubs")
      .then((res) => {
        commit("setPersonClubs", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getDeliveryMethods({ dispatch, commit, state }) {
    if (!state.companySubSystems?.some((x) => x.subSystemId == 19)) {
      return;
    }
    axios
      .get("sale/api/v1/DropDown/DeliveryMethods")
      .then((res) => {
        commit("setDeliveryMethods", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getPaymentMethods({ dispatch, commit, state }) {
    if (!state.companySubSystems?.some((x) => x.subSystemId == 19)) {
      return;
    }
    axios
      .get("sale/api/v1/DropDown/PaymentMethods")
      .then((res) => {
        commit("setPaymentMethods", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getOccasionTypes({ dispatch, commit, state }) {
    if (!state.companySubSystems?.some((x) => x.subSystemId == 19)) {
      return;
    }
    axios
      .get("sale/api/v1/DropDown/OccasionTypes")
      .then((res) => {
        commit("setOccasionTypes", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getCampaignTypes({ dispatch, commit, state }) {
    if (!state.companySubSystems?.some((x) => x.subSystemId == 19)) {
      return;
    }
    axios
      .get("sale/api/v1/DropDown/CampaignTypes")
      .then((res) => {
        commit("setCampaignTypes", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getSalesChannels({ dispatch, commit, state }) {
    if (!state.companySubSystems?.some((x) => x.subSystemId == 19)) {
      return;
    }
    axios
      .get("sale/api/v1/DropDown/SalesChannels")
      .then((res) => {
        commit("setSalesChannels", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getIntroducedTypes({ dispatch, commit, state }) {
    if (!state.companySubSystems?.some((x) => x.subSystemId == 19)) {
      return;
    }
    axios
      .get("sale/api/v1/DropDown/IntroducedTypes")
      .then((res) => {
        commit("setIntroducedTypes", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getTags({ dispatch, commit, state }) {
    if (!state.companySubSystems?.some((x) => x.subSystemId == 19)) {
      return;
    }
    axios
      .get("sale/api/v1/DropDown/Tags")
      .then((res) => {
        commit("setTags", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getProcessTypes({ dispatch, commit, state }) {
    if (!state.companySubSystems?.some((x) => x.subSystemId == 19)) {
      return;
    }
    axios
      .get("sale/api/v1/DropDown/ProcessTypes")
      .then((res) => {
        commit("setProcessTypes", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getFeedBackTypes({ dispatch, commit, state }) {
    if (!state.companySubSystems?.some((x) => x.subSystemId == 19)) {
      return;
    }
    axios
      .get("sale/api/v1/DropDown/FeedBackTypes")
      .then((res) => {
        commit("setFeedBackTypes", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getProcessServiceTypes({ dispatch, commit, state }) {
    if (!state.companySubSystems?.some((x) => x.subSystemId == 19)) {
      return;
    }
    axios
      .get("sale/api/v1/DropDown/ProcessServiceTypes")
      .then((res) => {
        commit("setProcessServiceTypes", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getFeedBacks({ dispatch, commit, state }) {
    if (!state.companySubSystems?.some((x) => x.subSystemId == 19)) {
      return;
    }
    axios
      .get("sale/api/v1/DropDown/Feedbacks")
      .then((res) => {
        commit("setFeedBacks", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getGrades({ dispatch, commit, state }, data) {
    if (!state.companySubSystems?.some((x) => x.subSystemId == 19)) {
      return;
    }
    axios
      .get("sale/api/v1/DropDown/Grades?" + data)
      .then((res) => {
        commit("setGrades", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getFeedbackQuestionOptions({ dispatch, commit, state }) {
    if (!state.companySubSystems?.some((x) => x.subSystemId == 19)) {
      return;
    }
    axios
      .get("sale/api/v1/DropDown/FeedbackQuestionOptions")
      .then((res) => {
        commit("setFeedbackQuestionOptions", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getAnswerTypes({ dispatch, commit, state }) {
    if (!state.companySubSystems?.some((x) => x.subSystemId == 19)) {
      return;
    }
    axios
      .get("sale/api/v1/DropDown/AnswerTypes")
      .then((res) => {
        commit("setAnswerTypes", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getSmsTemplates({ dispatch, commit, state }) {
    if (!state.companySubSystems?.some((x) => x.subSystemId == 19)) {
      return;
    }
    axios
      .get("sale/api/v1/DropDown/SendSmsTemplates")
      .then((res) => {
        commit("setSmsTemplates", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getSaleSettings({ dispatch, commit, state }) {
    if (!state.companySubSystems?.some((x) => x.subSystemId == 19)) {
      return;
    }
    axios
      .get("sale/api/v1/DropDown/Settings")
      .then((res) => {
        commit("setSaleSettings", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getSaleExcelSampleType({ dispatch, commit, state }) {
    if (!state.companySubSystems?.some((x) => x.subSystemId == 19)) {
      return;
    }
    axios
      .get("sale/api/v1/DropDown/ExcelSampleTypes")
      .then((res) => {
        commit("setSaleExcelSampleType", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getSaleExcelSampleDetailType({ dispatch, commit, state }, data) {
    if (!state.companySubSystems?.some((x) => x.subSystemId == 19)) {
      return;
    }
    axios
      .get("sale/api/v1/DropDown/ExcelSampleDetailTypes?" + data)
      .then((res) => {
        commit("setSaleExcelSampleDetailType", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getCancelStatuses({ dispatch, commit, state }) {
    if (!state.companySubSystems?.some((x) => x.subSystemId == 19)) {
      return;
    }
    axios
      .get("sale/api/v1/DropDown/CancelStatusDropdown")
      .then((res) => {
        commit("setCancelStatuses", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getReturnedFactorTypes({ dispatch, commit, state }) {
    if (!state.companySubSystems?.some((x) => x.subSystemId == 19)) {
      return;
    }
    axios
      .get("sale/api/v1/DropDown/ReturnedFactorTypeDropDown")
      .then((res) => {
        commit("setReturnedFactorTypes", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getSaleSaleTypes({ dispatch, commit, state }) {
    if (!state.companySubSystems?.some((x) => x.subSystemId == 19)) {
      return;
    }
    axios
      .get("sale/api/v1/DropDown/SaleTypes")
      .then((res) => {
        commit("setSaleSaleTypes", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getSalePricePolicesTypes({ dispatch, commit, state }) {
    if (!state.companySubSystems?.some((x) => x.subSystemId == 19)) {
      return;
    }
    axios
      .get("sale/api/v1/DropDown/SalePricePolices")
      .then((res) => {
        commit("setSalePricePolicesTypes", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getSaleFactorTypes({ dispatch, commit, state }) {
    if (!state.companySubSystems?.some((x) => x.subSystemId == 19)) {
      return;
    }
    axios
      .get("sale/api/v1/DropDown/SaleFactorTypes")
      .then((res) => {
        commit("setSaleFactorTypes", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getSaleCancelStatus({ dispatch, commit, state }) {
    if (!state.companySubSystems?.some((x) => x.subSystemId == 19)) {
      return;
    }
    axios
      .get("sale/api/v1/DropDown/CancelStatusDropdown")
      .then((res) => {
        commit("setSaleCancelStatus", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getSaleVoucherStatus({ dispatch, commit, state }) {
    if (!state.companySubSystems?.some((x) => x.subSystemId == 19)) {
      return;
    }
    axios
      .get("sale/api/v1/DropDown/VoucherStatusDropdown")
      .then((res) => {
        commit("setSaleVoucherStatus", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getSalePricePolices({ dispatch, commit, state }) {
    if (!state.companySubSystems?.some((x) => x.subSystemId == 19)) {
      return;
    }
    axios
      .get("sale/api/v1/DropDown/SalePricePolices")
      .then((res) => {
        commit("setSalePricePolices", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getSaleAgents({ dispatch, commit, state }) {
    if (!state.companySubSystems?.some((x) => x.subSystemId == 19)) {
      return;
    }
    axios
      .get("sale/api/v1/DropDown/Agents")
      .then((res) => {
        commit("setSaleAgents", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getFactorFormats({ dispatch, commit, state }) {
    if (!state.companySubSystems?.some((x) => x.subSystemId == 19)) {
      return;
    }
    axios
      .get("sale/api/v1/DropDown/FactorFormats")
      .then((res) => {
        commit("setFactorFormats", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getSaleSaleManager({ dispatch, commit, state }) {
    if (!state.companySubSystems?.some((x) => x.subSystemId == 19)) {
      return;
    }
    axios
      .get("sale/api/v1/DropDown/Sellers")
      .then((res) => {
        commit("setSaleSaleManager", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getSaleCommissionTypes({ dispatch, commit, state }) {
    if (!state.companySubSystems?.some((x) => x.subSystemId == 19)) {
      return;
    }
    axios
      .get("sale/api/v1/DropDown/CommissionTypes")
      .then((res) => {
        commit("setSaleCommissionTypes", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getSaleFactors({ dispatch, commit, state }) {
    if (!state.companySubSystems?.some((x) => x.subSystemId == 19)) {
      return;
    }
    axios
      .get("sale/api/v1/DropDown/SaleFactors")
      .then((res) => {
        commit("setSaleFactors", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getReturnSaleFactors({ dispatch, commit, state }) {
    if (!state.companySubSystems?.some((x) => x.subSystemId == 19)) {
      return;
    }
    axios
      .get("sale/api/v1/DropDown/ReturnSaleFactors")
      .then((res) => {
        commit("setReturnSaleFactors", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getSaleDiscountTypes({ dispatch, commit, state }) {
    if (!state.companySubSystems?.some((x) => x.subSystemId == 19)) {
      return;
    }
    axios
      .get("sale/api/v1/DropDown/DiscountTypes")
      .then((res) => {
        commit("setSaleDiscountTypes", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getSaleProcesses({ dispatch, commit, state }) {
    if (!state.companySubSystems?.some((x) => x.subSystemId == 19)) {
      return;
    }
    axios
      .get("sale/api/v1/DropDown/Process")
      .then((res) => {
        commit("setSaleProcesses", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getGoals({ dispatch, commit, state }) {
    if (!state.companySubSystems?.some((x) => x.subSystemId == 19)) {
      return;
    }
    axios
      .get("sale/api/v1/DropDown/Goals")
      .then((res) => {
        commit("setGoals", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getProjectTypes({ dispatch, commit, state }) {
    if (!state.companySubSystems?.some((x) => x.subSystemId == 19)) {
      return;
    }
    axios
      .get("sale/api/v1/DropDown/ProjectType")
      .then((res) => {
        commit("setProjectTypes", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getProjectExecutionPhases({ dispatch, commit, state }) {
    if (!state.companySubSystems?.some((x) => x.subSystemId == 19)) {
      return;
    }
    axios
      .get("sale/api/v1/DropDown/ProjectExecutionPhase")
      .then((res) => {
        commit("setProjectExecutionPhases", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getLeads({ dispatch, commit, state }) {
    if (!state.companySubSystems?.some((x) => x.subSystemId == 19)) {
      return;
    }
    axios
      .get("sale/api/v1/DropDown/Lead")
      .then((res) => {
        commit("setLeads", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getProjects({ dispatch, commit, state }) {
    if (!state.companySubSystems?.some((x) => x.subSystemId == 19)) {
      return;
    }
    axios
      .get("sale/api/v1/DropDown/Project")
      .then((res) => {
        commit("setProjects", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getWorkDescriptions({ dispatch, commit, state }) {
    if (!state.companySubSystems?.some((x) => x.subSystemId == 19)) {
      return;
    }
    axios
      .get("sale/api/v1/DropDown/WorkDescription")
      .then((res) => {
        commit("setWorkDescriptions", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getGiftTypes({ dispatch, commit, state }) {
    if (!state.companySubSystems?.some((x) => x.subSystemId == 19)) {
      return;
    }
    axios
      .get("sale/api/v1/DropDown/GiftTypes")
      .then((res) => {
        commit("setGiftTypes", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getCalculateTypes({ dispatch, commit, state }) {
    if (!state.companySubSystems?.some((x) => x.subSystemId == 19)) {
      return;
    }
    axios
      .get("sale/api/v1/DropDown/CalculateTypes")
      .then((res) => {
        commit("setCalculateTypes", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getHamsazSmsTemplates({ dispatch, commit, state }) {
    if (!state.companySubSystems?.some((x) => x.subSystemId == 19)) {
      return;
    }
    axios
      .get("sale/api/v1/DropDown/HamsazSendSmsTemplates")
      .then((res) => {
        commit("setHamsazSmsTemplates", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getHamsazSmsSettings({ dispatch, commit, state }) {
    if (!state.companySubSystems?.some((x) => x.subSystemId == 19)) {
      return;
    }
    axios
      .get("sale/api/v1/DropDown/HamsazSmsSettings")
      .then((res) => {
        commit("setHamsazSmsSettings", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getCampaigns({ dispatch, commit, state }) {
    if (!state.companySubSystems?.some((x) => x.subSystemId == 19)) {
      return;
    }
    axios
      .get("sale/api/v1/DropDown/Campaigns")
      .then((res) => {
        commit("setCampaigns", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
  getLeadSources({ dispatch, commit, state }) {
    if (!state.companySubSystems?.some((x) => x.subSystemId == 19)) {
      return;
    }
    axios
      .get("sale/api/v1/DropDown/LeadSource")
      .then((res) => {
        commit("setLeadSources", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
  getLeadStatuses({ dispatch, commit, state }) {
    if (!state.companySubSystems?.some((x) => x.subSystemId == 19)) {
      return;
    }
    axios
      .get("sale/api/v1/DropDown/LeadStatus")
      .then((res) => {
        commit("setLeadStatuses", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
  getLeadPropertys({ dispatch, commit, state }) {
    if (!state.companySubSystems?.some((x) => x.subSystemId == 19)) {
      return;
    }
    axios
      .get("sale/api/v1/DropDown/LeadProperty")
      .then((res) => {
        commit("setLeadPropertys", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
  getLeadTypes({ dispatch, commit, state }) {
    if (!state.companySubSystems?.some((x) => x.subSystemId == 19)) {
      return;
    }
    axios
      .get("sale/api/v1/DropDown/LeadType")
      .then((res) => {
        commit("setLeadTypes", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
  getLeadNotChances({ dispatch, commit, state }) {
    if (!state.companySubSystems?.some((x) => x.subSystemId == 19)) {
      return;
    }
    axios
      .get("sale/api/v1/operation/marketing/Chance/LeadNotChance")
      .then((res) => {
        commit("setLeadNotChances", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
  getChanceSaleStatuses({ dispatch, commit, state }) {
    if (!state.companySubSystems?.some((x) => x.subSystemId == 19)) {
      return;
    }
    axios
      .get("sale/api/v1/DropDown/ChanceSaleStatus")
      .then((res) => {
        commit("setChanceSaleStatuses", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
  getCampaignStatuses({ dispatch, commit, state }) {
    if (!state.companySubSystems?.some((x) => x.subSystemId == 19)) {
      return;
    }
    axios
      .get("sale/api/v1/DropDown/CampaignStatus")
      .then((res) => {
        commit("setCampaignStatuses", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
  getCampaignExecutionPhases({ dispatch, commit, state }) {
    if (!state.companySubSystems?.some((x) => x.subSystemId == 19)) {
      return;
    }
    axios
      .get("sale/api/v1/DropDown/CampaignExecutionPhase")
      .then((res) => {
        commit("setCampaignExecutionPhases", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
  getAgeGroups({ dispatch, commit, state }) {
    if (!state.companySubSystems?.some((x) => x.subSystemId == 19)) {
      return;
    }
    axios
      .get("sale/api/v1/DropDown/AgeGroup")
      .then((res) => {
        commit("setAgeGroups", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
  getChanceTypes({ dispatch, commit, state }) {
    if (!state.companySubSystems?.some((x) => x.subSystemId == 19)) {
      return;
    }
    axios
      .get("sale/api/v1/DropDown/ChanceType")
      .then((res) => {
        commit("setChanceTypes", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
  getChanceStatuses({ dispatch, commit, state }) {
    if (!state.companySubSystems?.some((x) => x.subSystemId == 19)) {
      return;
    }
    axios
      .get("sale/api/v1/DropDown/ChanceStatus")
      .then((res) => {
        commit("setChanceStatuses", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
  getChanceResults({ dispatch, commit, state }) {
    if (!state.companySubSystems?.some((x) => x.subSystemId == 19)) {
      return;
    }
    axios
      .get("sale/api/v1/DropDown/ChanceResult")
      .then((res) => {
        commit("setChanceResults", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
  getSaleLines({ dispatch, commit, state }) {
    if (!state.companySubSystems?.some((x) => x.subSystemId == 19)) {
      return;
    }
    return axios
      .get("sale/api/v1/DropDown/SaleLine")
      .then((res) => {
        commit("setSaleLines", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
  getSaleLineStages({ dispatch, commit, state }, saleLineId) {
    if (!state.companySubSystems?.some((x) => x.subSystemId == 19)) {
      return;
    }
    return axios
      .get("sale/api/v1/DropDown/SaleStage?saleLineId=" + saleLineId)
      .then((res) => {
        commit("setSaleLineStages", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
  getSaleStageTypes({ dispatch, commit, state }) {
    if (!state.companySubSystems?.some((x) => x.subSystemId == 19)) {
      return;
    }
    return axios
      .get("sale/api/v1/DropDown/SaleStageType")
      .then((res) => {
        commit("setSaleStageTypes", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
  getChancePrioritys({ dispatch, commit, state }) {
    if (!state.companySubSystems?.some((x) => x.subSystemId == 19)) {
      return;
    }
    axios
      .get("sale/api/v1/DropDown/ChancePriority")
      .then((res) => {
        commit("setChancePrioritys", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
  getFailedSaleReasons({ dispatch, commit, state }) {
    if (!state.companySubSystems?.some((x) => x.subSystemId == 19)) {
      return;
    }
    axios
      .get("sale/api/v1/DropDown/FailedSaleReason")
      .then((res) => {
        commit("setFailedSaleReasons", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
  getStrengthWeaknesses({ dispatch, commit, state }, data) {
    if (!state.companySubSystems?.some((x) => x.subSystemId == 19)) {
      return;
    }
    axios
      .get("sale/api/v1/DropDown/StrengthWeakness?" + data)
      .then((res) => {
        commit("setStrengthWeaknesses", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
  getStrengthWeaknessTypes({ dispatch, commit, state }) {
    if (!state.companySubSystems?.some((x) => x.subSystemId == 19)) {
      return;
    }
    axios
      .get("sale/api/v1/DropDown/StrengthWeaknessType")
      .then((res) => {
        commit("setStrengthWeaknessTypes", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
  getTaskStatuses({ dispatch, commit, state }) {
    if (!state.companySubSystems?.some((x) => x.subSystemId == 19)) {
      return;
    }
    axios
      .get("sale/api/v1/DropDown/TaskStatus")
      .then((res) => {
        commit("setTaskStatuses", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getTaskDateTypes({ dispatch, commit, state }) {
    if (!state.companySubSystems?.some((x) => x.subSystemId == 19)) {
      return;
    }
    if (state.taskDateTypes.length) return;
    axios
      .get("sale/api/v1/DropDown/TaskDateType")
      .then((res) => {
        commit("setTaskDateTypes", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getTaskDeleteScopes({ dispatch, commit, state }) {
    if (!state.companySubSystems?.some((x) => x.subSystemId == 19)) {
      return;
    }
    if (state.taskDeleteScopes.length) return;
    axios
      .get("sale/api/v1/DropDown/TaskDeleteScope")
      .then((res) => {
        commit("setTaskDeleteScopes", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
  getTaskCategorys({ dispatch, commit, state }) {
    if (!state.companySubSystems?.some((x) => x.subSystemId == 19)) {
      return;
    }
    axios
      .get("sale/api/v1/DropDown/TaskCategory")
      .then((res) => {
        commit("setTaskCategorys", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
  getNoteCategorys({ dispatch, commit, state }) {
    if (!state.companySubSystems?.some((x) => x.subSystemId == 19)) {
      return;
    }
    axios
      .get("sale/api/v1/DropDown/NoteCategories")
      .then((res) => {
        commit("setNoteCategorys", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
  getNoteSubjects({ dispatch, commit, state }) {
    if (!state.companySubSystems?.some((x) => x.subSystemId == 19)) {
      return;
    }
    axios
      .get("sale/api/v1/DropDown/NoteSubjects")
      .then((res) => {
        commit("setNoteSubjects", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
  getNoteStatuses({ dispatch, commit, state }) {
    if (!state.companySubSystems?.some((x) => x.subSystemId == 19)) {
      return;
    }
    axios
      .get("sale/api/v1/DropDown/NoteStatuses")
      .then((res) => {
        commit("setNoteStatuses", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
  getHamyarRequestTypes({ dispatch, commit, state }) {
    if (!state.companySubSystems?.some((x) => x.subSystemId == 19)) {
      return;
    }
    axios
      .get("sale/api/v1/DropDown/RequestTypes")
      .then((res) => {
        commit("setHamyarRequestTypes", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
  getRequestStatuses({ dispatch, commit, state }) {
    if (!state.companySubSystems?.some((x) => x.subSystemId == 19)) {
      return;
    }
    axios
      .get("sale/api/v1/DropDown/RequestStatuses")
      .then((res) => {
        commit("setRequestStatuses", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
  getServiceSupports({ dispatch, commit, state }) {
    if (!state.companySubSystems?.some((x) => x.subSystemId == 19)) {
      return;
    }
    axios
      .get("sale/api/v1/DropDown/ServiceSupports")
      .then((res) => {
        commit("setServiceSupports", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getServiceSupportSubjects({ dispatch, commit }) {
    axios
      .get("sale/api/v1/DropDown/ServiceSupportSubject")
      .then((res) => {
        commit("setServiceSupportSubjects", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
  getServiceSupportStatuses({ dispatch, commit }) {
    axios
      .get("sale/api/v1/DropDown/ServiceSupportStatus")
      .then((res) => {
        commit("setServiceSupportStatuses", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
  getServiceSupportCategories({ dispatch, commit }) {
    axios
      .get("sale/api/v1/DropDown/ServiceSupportCategorys")
      .then((res) => {
        commit("setServiceSupportCategories", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
  getServiceSupportAnnouncementTypes({ dispatch, commit }) {
    axios
      .get("sale/api/v1/DropDown/ServiceSupportAnnouncementTypes")
      .then((res) => {
        commit("setServiceSupportAnnouncementTypes", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
  getServiceSupportActionTypes({ dispatch, commit }) {
    axios
      .get("sale/api/v1/DropDown/ServiceSupportActionTypes")
      .then((res) => {
        commit("setServiceSupportActionTypes", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
  getHamyarContractTypes({ dispatch, commit }) {
    axios
      .get("sale/api/v1/DropDown/ContractTypes")
      .then((res) => {
        commit("setHamyarContractTypes", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
  getHamyarContractStatuses({ dispatch, commit }) {
    axios
      .get("sale/api/v1/DropDown/ContractStatus")
      .then((res) => {
        commit("setHamyarContractStatuses", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
  getChances({ dispatch, commit }, leadId) {
    axios
      .get(
        "sale/api/v1/DropDown/Chance" +
          (leadId ? "?leadId=" + encodeURIComponent(leadId) : ""),
      )
      .then((res) => {
        commit("setChances", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
  getCalls({ dispatch, commit, state }) {
    if (!state.companySubSystems?.some((x) => x.subSystemId == 19)) {
      return;
    }
    axios
      .get("sale/api/v1/DropDown/Calls")
      .then((res) => {
        commit("setCalls", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
  getMessages({ dispatch, commit, state }) {
    if (!state.companySubSystems?.some((x) => x.subSystemId == 19)) {
      return;
    }
    axios
      .get("sale/api/v1/DropDown/Messages")
      .then((res) => {
        commit("setMessages", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
  getContracts({ dispatch, commit, state }) {
    if (!state.companySubSystems?.some((x) => x.subSystemId == 19)) {
      return;
    }
    axios
      .get("sale/api/v1/DropDown/Contract")
      .then((res) => {
        commit("setContracts", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
  getMeetings({ dispatch, commit, state }) {
    if (!state.companySubSystems?.some((x) => x.subSystemId == 19)) {
      return;
    }
    axios
      .get("sale/api/v1/DropDown/Meetings")
      .then((res) => {
        commit("setMeetings", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getTasks({ dispatch, commit, state }) {
    if (!state.companySubSystems?.some((x) => x.subSystemId == 19)) {
      return;
    }
    axios
      .get("sale/api/v1/DropDown/Tasks")
      .then((res) => {
        commit("setTasks", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
  getMessageStatuses({ dispatch, commit, state }) {
    if (!state.companySubSystems?.some((x) => x.subSystemId == 19)) {
      return;
    }
    axios
      .get("sale/api/v1/DropDown/MessageStatuses")
      .then((res) => {
        commit("setMessageStatuses", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
  getMessageTypes({ dispatch, commit, state }) {
    if (!state.companySubSystems?.some((x) => x.subSystemId == 19)) {
      return;
    }
    axios
      .get("sale/api/v1/DropDown/MessageTypes")
      .then((res) => {
        commit("setMessageTypes", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
  getMessageActions({ dispatch, commit, state }) {
    if (!state.companySubSystems?.some((x) => x.subSystemId == 19)) {
      return;
    }
    axios
      .get("sale/api/v1/DropDown/MessageActions")
      .then((res) => {
        commit("setMessageActions", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
  getCallTypes({ dispatch, commit, state }) {
    if (!state.companySubSystems?.some((x) => x.subSystemId == 19)) {
      return;
    }
    axios
      .get("sale/api/v1/DropDown/CallTypes")
      .then((res) => {
        commit("setCallTypes", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
  getCallStatuses({ dispatch, commit, state }) {
    if (!state.companySubSystems?.some((x) => x.subSystemId == 19)) {
      return;
    }
    axios
      .get("sale/api/v1/DropDown/CallStatuses")
      .then((res) => {
        commit("setCallStatuses", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
  getCallNatures({ dispatch, commit, state }) {
    if (!state.companySubSystems?.some((x) => x.subSystemId == 19)) {
      return;
    }
    axios
      .get("sale/api/v1/DropDown/Natures")
      .then((res) => {
        commit("setCallNatures", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
  getCallCategories({ dispatch, commit, state }) {
    if (!state.companySubSystems?.some((x) => x.subSystemId == 19)) {
      return;
    }
    axios
      .get("sale/api/v1/DropDown/CallCategories")
      .then((res) => {
        commit("setCallCategories", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
  getCallSubjects({ dispatch, commit, state }) {
    if (!state.companySubSystems?.some((x) => x.subSystemId == 19)) {
      return;
    }
    axios
      .get("sale/api/v1/DropDown/CallSubjects")
      .then((res) => {
        commit("setCallSubjects", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
  getLeadAddressTypes({ dispatch, commit, state }) {
    if (!state.companySubSystems?.some((x) => x.subSystemId == 19)) {
      return;
    }
    axios
      .get("sale/api/v1/DropDown/LeadAddressType")
      .then((res) => {
        commit("setLeadAddressTypes", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
  getMeetingStatuses({ dispatch, commit, state }) {
    if (!state.companySubSystems?.some((x) => x.subSystemId == 19)) {
      return;
    }
    axios
      .get("sale/api/v1/DropDown/MeetingStatus")
      .then((res) => {
        commit("setMeetingStatuses", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getCheckListTypes({ dispatch, commit, state }) {
    if (!state.companySubSystems?.some((x) => x.subSystemId == 19)) {
      return;
    }
    axios
      .get("sale/api/v1/DropDown/CheckListTypes")
      .then((res) => {
        commit("setCheckListTypes", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getSuites({ dispatch, commit, state }, data) {
    if (!state.companySubSystems?.some((x) => x.subSystemId == 19)) {
      return;
    }
    axios
      .get("sale/api/v1/DropDown/Suites?" + data)
      .then((res) => {
        commit("setSuites", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getParticipation({ dispatch, commit, state }, data) {
    if (!state.companySubSystems?.some((x) => x.subSystemId == 19)) {
      return;
    }
    axios
      .get("sale/api/v1/DropDown/Participation?" + data)
      .then((res) => {
        commit("setParticipation", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getCrimesRewardSubject({ dispatch, commit, state }, data) {
    if (!state.companySubSystems?.some((x) => x.subSystemId == 19)) {
      return;
    }
    axios
      .get("sale/api/v1/DropDown/CrimesRewardSubject?" + data)
      .then((res) => {
        commit("setCrimesRewardSubject", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getPaymentNotificationType({ dispatch, commit, state }) {
    if (!state.companySubSystems?.some((x) => x.subSystemId == 19)) {
      return;
    }
    axios
      .get("sale/api/v1/DropDown/PaymentNotificationType")
      .then((res) => {
        commit("setPaymentNotificationType", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getEstimationSubject({ dispatch, commit, state }) {
    if (!state.companySubSystems?.some((x) => x.subSystemId == 19)) {
      return;
    }
    axios
      .get("sale/api/v1/DropDown/EstimationSubject")
      .then((res) => {
        commit("setEstimationSubject", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getCrimesRewardType({ dispatch, commit, state }) {
    if (!state.companySubSystems?.some((x) => x.subSystemId == 19)) {
      return;
    }
    axios
      .get("sale/api/v1/DropDown/crimesRewardType")
      .then((res) => {
        commit("setCrimesRewardType", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getSaleTeams({ dispatch, commit, state }) {
    if (!state.companySubSystems?.some((x) => x.subSystemId == 19)) {
      return;
    }
    axios
      .get("sale/api/v1/DropDown/SaleTeam?isActive=true")
      .then((res) => {
        commit("setSaleTeams", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getSaleRegions({ dispatch, commit, state }) {
    if (!state.companySubSystems?.some((x) => x.subSystemId == 19)) {
      return;
    }
    axios
      .get("sale/api/v1/DropDown/SaleRegion?isActive=true")
      .then((res) => {
        commit("setSaleRegions", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  // PPARAK DropDowns  -----------------------------------------------
  getPrakCommodityGroup({ dispatch, commit }) {
    axios
      .get("Parak/api/v1/DropDown/CommodityGroups")
      .then((res) => {
        commit("setPrakCommodityGroup", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getParakCommodities({ dispatch, commit }) {
    axios
      .get("Parak/api/v1/DropDown/Commodities")
      .then((res) => {
        commit("setParakCommodities", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getParakPersonDealTypes({ dispatch, commit }) {
    axios
      .get("Parak/api/v1/DropDown/PersonDealTypes")
      .then((res) => {
        commit("setParakPersonDealTypes", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getParakCottage({ dispatch, commit }) {
    axios
      .get("Parak/api/v1/DropDown/Cottages")
      .then((res) => {
        commit("setParakCottage", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getParakSettlementType({ dispatch, commit }) {
    axios
      .get("Parak/api/v1/DropDown/SettlementTypes ")
      .then((res) => {
        commit("setParakSettlementType", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getParakOrderOperation({ dispatch, commit }) {
    axios
      .get("Parak/api/v1/DropDown/OrderOperations")
      .then((res) => {
        commit("setParakOrderOperations", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getParakPurchases({ dispatch, commit }) {
    axios
      .get("Parak/api/v1/DropDown/Purchases")
      .then((res) => {
        commit("setParakPurchases", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getParakOrders({ dispatch, commit }) {
    axios
      .get("Parak/api/v1/DropDown/Orders")
      .then((res) => {
        commit("setParakOrders", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getParakVoucherType({ dispatch, commit }) {
    axios
      .get("Parak/api/v1/DropDown/VoucherTypes")
      .then((res) => {
        commit("setParakVoucherType", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getParakLadingOperation({ dispatch, commit }) {
    axios
      .get("Parak/api/v1/DropDown/LadingOperations")
      .then((res) => {
        commit("setParakLadingOperation", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  // Mrp2Valvs DropDowns  -----------------------------------------------
  getProductionGroups({ dispatch, commit }, data) {
    axios
      .get("Mrp2Valvs/api/v1/DropDown/ProductionGroups?" + data)
      .then((res) => {
        commit("setProductionGroups", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getPurchaseContracts({ dispatch, commit }) {
    axios
      .get("Mrp2Valvs/api/v1/DropDown/PurchaseContracts")
      .then((res) => {
        commit("setPurchaseContracts", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getSaleTypes({ dispatch, commit }) {
    axios
      .get("Mrp2Valvs/api/v1/DropDown/SaleTypes")
      .then((res) => {
        commit("setSaleTypes", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getOrderCommodities({ dispatch, commit }) {
    axios
      .get("Mrp2Valvs/api/v1/DropDown/OrderCommodities")
      .then((res) => {
        commit("setOrderCommodities", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getOrderCommodityStatus({ dispatch, commit }) {
    axios
      .get("Mrp2Valvs/api/v1/DropDown/OrderCommodityStatus")
      .then((res) => {
        commit("setOrderCommodityStatus", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getProductionGroupSuppliers({ dispatch, commit }, data) {
    axios
      .get("Mrp2Valvs/api/v1/DropDown/ProductionGroupSuppliers?" + data)
      .then((res) => {
        commit("setProductionGroupSuppliers", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getCommodityAdditionalInfos({ dispatch, commit }, data) {
    axios
      .get("Mrp2Valvs/api/v1/DropDown/CommodityAdditionalInfos?" + data)
      .then((res) => {
        commit("setCommodityAdditionalInfos", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getInspectionLevels({ dispatch, commit }) {
    axios
      .get("Mrp2Valvs/api/v1/DropDown/InspectionLevels")
      .then((res) => {
        commit("setInspectionLevels", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  // POPCS DropDowns  -----------------------------------------------
  getBomSetting({ dispatch, commit }) {
    axios
      .get("opcs/api/v1/basic/Bom/GetSetting")
      .then((res) => {
        commit("setBomSetting", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getProductions({ dispatch, commit }) {
    axios
      .get("opcs/api/v1/DropDown/Productions")
      .then((res) => {
        commit("setProductions", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getOrderBoms({ dispatch, commit }, data) {
    axios
      .get("opcs/api/v1/DropDown/Boms?" + data)
      .then((res) => {
        commit("setOrderBoms", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  // Hrms DropDowns  -----------------------------------------------
  getTaxRateTypes({ dispatch, commit }) {
    axios
      .get("Hrms/api/v1/DropDown/TaxRateTypes")
      .then((res) => {
        commit("setTaxRateTypes", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getAddOrMinusTypes({ dispatch, commit }, data) {
    axios
      .get("Hrms/api/v1/DropDown/AddOrMinusTypes" + data)
      .then((res) => {
        commit("setAddOrMinusTypes", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getContractTypes({ dispatch, commit }) {
    axios
      .get("Hrms/api/v1/DropDown/ContractTypes")
      .then((res) => {
        commit("setContractTypes", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getLeaveTypes({ dispatch, commit }) {
    axios
      .get("Hrms/api/v1/DropDown/LeaveTypes")
      .then((res) => {
        commit("setLeaveTypes", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getJobGroups({ dispatch, commit }) {
    axios
      .get("Hrms/api/v1/DropDown/JobGroups")
      .then((res) => {
        commit("setJobGroups", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getInsuranceWorkplaces({ dispatch, commit }) {
    axios
      .get("Hrms/api/v1/DropDown/InsuranceWorkplaces")
      .then((res) => {
        commit("setInsuranceWorkplaces", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getAgreementRows({ dispatch, commit }) {
    axios
      .get("Hrms/api/v1/DropDown/AgreementRows")
      .then((res) => {
        commit("setAgreementRows", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getCalculateDeductionRateTypes({ dispatch, commit }) {
    axios
      .get("Hrms/api/v1/DropDown/CalculateDeductionRateTypes")
      .then((res) => {
        commit("setCalculateDeductionRateTypes", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getFormulas({ dispatch, commit }, data) {
    axios
      .get("Hrms/api/v1/DropDown/Formulas?" + data)
      .then((res) => {
        commit("setFormulas", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getExemptionTypes({ dispatch, commit }) {
    axios
      .get("Hrms/api/v1/DropDown/ExemptionTypes")
      .then((res) => {
        commit("setExemptionTypes", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getCalculateTaxForHourlys({ dispatch, commit }) {
    axios
      .get("Hrms/api/v1/DropDown/CalculateTaxForHourly")
      .then((res) => {
        commit("setCalculateTaxForHourlys", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getCalculateTaxTypes({ dispatch, commit }) {
    axios
      .get("Hrms/api/v1/DropDown/CalculateTaxTypes")
      .then((res) => {
        commit("setCalculateTaxTypes", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getLegalTaxExceptions({ dispatch, commit }) {
    axios
      .get("Hrms/api/v1/DropDown/LegalTaxExceptions")
      .then((res) => {
        commit("setLegalTaxExceptions", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getFunctionTypes({ dispatch, commit }) {
    axios
      .get("Hrms/api/v1/DropDown/FunctionTypes")
      .then((res) => {
        commit("setFunctionTypes", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getCalculateOffOverTimeTypes({ dispatch, commit }) {
    axios
      .get("Hrms/api/v1/DropDown/CalculateOffOverTimeTypes")
      .then((res) => {
        commit("setCalculateOffOverTimeTypes", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getBenefitsAndDeductions({ dispatch, commit }, data) {
    axios
      .get("Hrms/api/v1/DropDown/BenefitsAndDeductions?" + data)
      .then((res) => {
        commit("setBenefitsAndDeductions", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getAdditionalContractParameters({ dispatch, commit }) {
    axios
      .get("Hrms/api/v1/DropDown/AdditionalContractParameters")
      .then((res) => {
        commit("setAdditionalContractParameters", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getExcelSampleType({ dispatch, commit }) {
    axios
      .get("Hrms/api/v1/DropDown/ExcelSampleType")
      .then((res) => {
        commit("setExcelSampleType", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getExcelSampleDetailType({ dispatch, commit }) {
    axios
      .get("Hrms/api/v1/DropDown/ExcelSampleDetailType")
      .then((res) => {
        commit("setExcelSampleDetailType", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getExcelSampleDetailInformationType({ dispatch, commit }) {
    axios
      .get("Hrms/api/v1/DropDown/ExcelSampleDetailInformationType")
      .then((res) => {
        commit("setExcelSampleDetailInformationType", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getExcelSampleDetailTurnIntoType({ dispatch, commit }) {
    axios
      .get("Hrms/api/v1/DropDown/ExcelSampleDetailTurnIntoType")
      .then((res) => {
        commit("setExcelSampleDetailTurnIntoType", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getShamsiMonths({ dispatch, commit }) {
    axios
      .get("Hrms/api/v1/DropDown/ShamsiMonths")
      .then((res) => {
        commit("setShamsiMonths", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getExcelSamples({ dispatch, commit }) {
    axios
      .get("Hrms/api/v1/DropDown/ExcelSamples")
      .then((res) => {
        commit("setExcelSamples", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getEmployeeClubPermissions({ dispatch, commit }) {
    return axios
      .get("Hrms/api/v1/DropDown/EmployeeClubPermissions")
      .then((res) => {
        commit("setEmployeeClubPermissions", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  // PTAX DropDowns  -----------------------------------------------
  // مقادیر و عنوان‌ها مستقیم از Tax.API خوانده می‌شوند و در فرانت ثابت نیستند

  getTaxBillTypes({ dispatch, commit }) {
    return axios
      .get("tax/api/v1/DropDown/LoadBillTypes")
      .then((res) => {
        commit("setTaxBillTypes", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getTaxBillSubjects({ dispatch, commit }) {
    return axios
      .get("tax/api/v1/DropDown/LoadBillSubjects")
      .then((res) => {
        commit("setTaxBillSubjects", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getTaxBuyerTypes({ dispatch, commit }) {
    return axios
      .get("tax/api/v1/DropDown/LoadBuyerTypes")
      .then((res) => {
        commit("setTaxBuyerTypes", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getTaxClearingMethods({ dispatch, commit }) {
    return axios
      .get("tax/api/v1/DropDown/LoadClearingMethods")
      .then((res) => {
        commit("setTaxClearingMethods", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getTaxInvoiceStatuses({ dispatch, commit }) {
    return axios
      .get("tax/api/v1/DropDown/LoadInvoiceStatuses")
      .then((res) => {
        commit("setTaxInvoiceStatuses", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getTaxCurrencyTypes({ dispatch, commit }) {
    return axios
      .get("tax/api/v1/DropDown/LoadCurrencyTypes")
      .then((res) => {
        commit("setTaxCurrencyTypes", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getTaxOrganizationTypes({ dispatch, commit }) {
    return axios
      .get("tax/api/v1/DropDown/LoadOrganizationTypes")
      .then((res) => {
        commit("setTaxOrganizationTypes", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getTaxMltTypes({ dispatch, commit }) {
    return axios
      .get("tax/api/v1/DropDown/LoadMltTypes")
      .then((res) => {
        commit("setTaxMltTypes", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  // الگوی صورتحساب به نوع صورتحساب وابسته است؛ هر نوع یک بار خوانده و کش می‌شود
  getTaxBillPatterns({ dispatch, commit, state }, billTypeId) {
    if (!billTypeId || state.taxBillPatterns[billTypeId]) {
      return Promise.resolve();
    }
    return axios
      .get("tax/api/v1/DropDown/LoadBillPatterns?billTypeId=" + billTypeId)
      .then((res) => {
        commit("setTaxBillPatterns", {
          billTypeId,
          items: res.data.data || [],
        });
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
};
